import { React, useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-scroll";

const NavBar = () => {
  const [nav, setNav] = useState(false);

  const links = [
    {
      id: 1,
      link: "home",
    },
    {
      id: 2,
      link: "about",
    },
    {
      id: 3,
      link: "portfolio",
    },
    {
      id: 4,
      link: "experience",
    },
    {
      id: 5,
      link: "contact",
      styling:
        "bg-black px-4 py-3 rounded-md bg-gradient-to-r from-[#2e7850] to-[#103b24]",
    },
  ];

  return (
    <div className="flex justify-between items-center w-full h-20 text-[#eeeeee] bg-red-dark fixed px-4">
      <div>
        <Link to="home" className="cursor-pointer text-5xl font-signature ml-2">
          Konstantin
        </Link>
      </div>

      <ul className="hidden md:flex">
        {links.map(({ id, link, styling }) => (
          <li
            key={id}
            className="px-4 cursor-pointer capitalize font-medium text-[#eeeeee] hover:scale-125 duration-200"
          >
            <Link
              className={styling}
              to={link}
              smooth
              duration={500}
              offset={-80}
            >
              {link}
            </Link>
          </li>
        ))}
      </ul>

      <div
        onClick={() => setNav(!nav)}
        className="cursor-pointer pr-4 z-10 text-pink-light md:hidden"
      >
        {nav ? <FaTimes size={30} /> : <FaBars size={30} />}
      </div>

      {nav && (
        <ul className="flex flex-col justify-center items-center absolute top-0 left-0 w-full h-screen bg-gradient-to-b from-red-dark to-red-light text-pink-light">
          {links.map(({ id, link }) => (
            <li
              key={id}
              className="px-4 cursor-pointer capitalize py-6 text-4xl"
            >
              <Link
                to={link}
                onClick={() => setNav(!nav)}
                smooth
                duration={500}
                offset={-65}
              >
                {link}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default NavBar;
